import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FileUploadComponent } from '../components/file-upload.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    declarations: [
        FileUploadComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule
    ],
    exports: [
        FileUploadComponent
    ]
})
export class FileUploadModule { }
